module.exports = __webpack_public_path__ + "static/media/YF01_9.57b132eb.jpg";